module.exports = __webpack_public_path__ + "media/images/kml_legend-3b9604186192e8dae585ff9fa319eaba.png";